import { List, useRecordContext } from "react-admin";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { Row } from "../../misc/Row";
import { AccessDenied } from "../../misc/AccessDenied";
import { grants } from "../../backoffice.access_control";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { SubscriptionPackagesDataGrid } from "./SubscriptionPackagesDataGrid";

export function DrivingSchoolSubscriptionPackages() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!grants.has("SubscriptionPackage:list")) {
    return <AccessDenied />;
  }

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>AUTOVIO Pro</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <div style={{ position: "relative" }}>
      <Row
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
      >
        <PageTitle documentTitle="AUTOVIO Pro">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>AUTOVIO Pro</h2>
        </PageTitle>
        {grants.has("SubscriptionPackage:create") && (
          <>
            <IconButton
              aria-label="AUTOVIO Pro Paket hinzufügen"
              color="primary"
              onClick={() => navigate("/subscriptionPackages/create")}
              size="small"
              sx={{ display: { xs: "inline-flex", sm: "none" } }}
            >
              <AddIcon />
            </IconButton>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => navigate("/subscriptionPackages/create")}
              size="small"
              sx={{ display: { xs: "none", sm: "inline-flex" } }}
            >
              Hinzufügen
            </Button>
          </>
        )}
      </Row>
      <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolSubscriptionPackages">
        <List
          resource="subscriptionPackages"
          title=" "
          actions={false}
          filter={{ drivingSchoolId: drivingSchool.id }}
          storeKey={`DrivingSchoolSubscriptionPackages@${drivingSchool.id}`}
          sort={/* initial sort order: */ { field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <SubscriptionPackagesDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
